/** Lunes = 0 … Domingo = 6 */
export const DIAS_SEMANA_ORDEN = [
  { id: 0, label: 'Lunes', labelCorto: 'Lun' },
  { id: 1, label: 'Martes', labelCorto: 'Mar' },
  { id: 2, label: 'Miércoles', labelCorto: 'Mié' },
  { id: 3, label: 'Jueves', labelCorto: 'Jue' },
  { id: 4, label: 'Viernes', labelCorto: 'Vie' },
  { id: 5, label: 'Sábado', labelCorto: 'Sáb' },
  { id: 6, label: 'Domingo', labelCorto: 'Dom' },
];

const RE_HM = /^\d{2}:\d{2}$/;

/** @returns {Record<number, { desde: string, hasta: string }[]>} */
export function estadoVacioSemana() {
  /** @type {Record<number, { desde: string, hasta: string }[]>} */
  const o = {};
  for (const { id } of DIAS_SEMANA_ORDEN) o[id] = [];
  return o;
}

function minutos(hhmm) {
  const [h, m] = String(hhmm || '').split(':').map((x) => Number(x));
  if (!Number.isFinite(h) || !Number.isFinite(m)) return NaN;
  return h * 60 + m;
}

/**
 * @param {unknown} prof
 * @returns {Record<number, { desde: string, hasta: string }[]>}
 */
export function slotsDesdePerfil(prof) {
  const raw = prof?.disponibilidad_semana;
  const st = estadoVacioSemana();
  if (!Array.isArray(raw) || !raw.length) return st;
  for (const it of raw) {
    const dia = Number(it?.dia);
    const desde = String(it?.desde || '').trim();
    const hasta = String(it?.hasta || '').trim();
    if (dia < 0 || dia > 6 || !RE_HM.test(desde) || !RE_HM.test(hasta)) continue;
    if (!Array.isArray(st[dia])) st[dia] = [];
    if (st[dia].length >= 2) continue;
    st[dia].push({ desde, hasta });
  }
  return st;
}

/**
 * @param {Record<number, { desde: string, hasta: string }[]>} estado
 * @returns {{ dia: number, desde: string, hasta: string }[]}
 */
export function firestoreSlotsDesdeEstado(estado) {
  const out = [];
  for (const { id } of DIAS_SEMANA_ORDEN) {
    const tramos = estado[id];
    if (!Array.isArray(tramos)) continue;
    for (const t of tramos) {
      const desde = String(t?.desde || '').trim();
      const hasta = String(t?.hasta || '').trim();
      if (!desde || !hasta) continue;
      out.push({ dia: id, desde, hasta });
    }
  }
  return out.slice(0, 21);
}

/**
 * @param {{ dia: number, desde: string, hasta: string }[]} slots
 */
export function resumenDisponibilidad(slots) {
  if (!slots.length) return '';
  const byDay = estadoVacioSemana();
  for (const s of slots) {
    if (s.dia < 0 || s.dia > 6) continue;
    if (!byDay[s.dia]) byDay[s.dia] = [];
    byDay[s.dia].push({ desde: s.desde, hasta: s.hasta });
  }
  const parts = [];
  for (const { id, labelCorto } of DIAS_SEMANA_ORDEN) {
    const tr = byDay[id];
    if (!tr?.length) continue;
    const txt = tr.map((t) => `${t.desde}–${t.hasta}`).join(', ');
    parts.push(`${labelCorto} ${txt}`);
  }
  return parts.join('; ');
}

/**
 * @param {{ dia: number, desde: string, hasta: string }[]} slots
 */
export function validarDisponibilidadSemana(slots) {
  if (!slots.length) {
    return { ok: false, error: 'Marcá al menos un día con horario.' };
  }
  for (const s of slots) {
    if (s.dia < 0 || s.dia > 6) {
      return { ok: false, error: 'Día inválido en disponibilidad.' };
    }
    if (!RE_HM.test(s.desde) || !RE_HM.test(s.hasta)) {
      return { ok: false, error: 'Usá horarios en formato HH:MM.' };
    }
    const a = minutos(s.desde);
    const b = minutos(s.hasta);
    if (!(a < b)) {
      return { ok: false, error: 'La hora desde tiene que ser menor que hasta.' };
    }
  }
  const res = resumenDisponibilidad(slots);
  if (res.length > 500) {
    return { ok: false, error: 'Disponibilidad demasiado larga.' };
  }
  return { ok: true };
}

/** Opciones HH:MM cada 30 min */
export function listaOpcionesMediaHora() {
  const o = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 30]) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      o.push(`${hh}:${mm}`);
    }
  }
  return o;
}

/**
 * @param {unknown} prof
 */
export function textoDisponibilidadParaPublico(prof) {
  const slots = Array.isArray(prof?.disponibilidad_semana) ? prof.disponibilidad_semana : [];
  if (slots.length) {
    const r = resumenDisponibilidad(
      slots
        .map((x) => ({
          dia: Number(x?.dia),
          desde: String(x?.desde || '').trim(),
          hasta: String(x?.hasta || '').trim(),
        }))
        .filter((x) => x.dia >= 0 && x.dia <= 6 && RE_HM.test(x.desde) && RE_HM.test(x.hasta))
    );
    if (r.trim()) return r;
  }
  return String(prof?.disponibilidad || '').trim();
}

/** Lunes = 0 … Domingo = 6 (mismo criterio que `DIAS_SEMANA_ORDEN`). */
export function diaSemanaMLVDesdeDate(d = new Date()) {
  const js = d.getDay();
  return (js + 6) % 7;
}

/**
 * @param {unknown} prof
 * @param {number} dia 0–6
 */
export function perfilTieneDisponibilidadEnDia(prof, dia) {
  const st = slotsDesdePerfil(prof);
  return Array.isArray(st[dia]) && st[dia].length > 0;
}
